import { ListaClientes, Container } from "../../components";

export const ClientesCRM = () => (
  <Container header titulo="Editar clientes">
    <ListaClientes />
  </Container>
);
